import React from 'react'
import {
  HomeFilled,
  InfoCircleFilled,
  DatabaseFilled,
  TagsFilled,
  StarFilled,
  BugFilled,
} from '@ant-design/icons'

export const Nav30DataSource = {
  wrapper: { className: 'header3 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header3-logo',
    children:
      '/lrmrepo.svg',
  },
  Menu: {
    className: 'header3-menu',
    children: [
      {
        name: '/',
        className: 'header3-item',
        children: {
          href: '/',
          children: [
            {
              children: (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <HomeFilled />&nbsp;Home
                </div>
              ),
              name: 'text',
            },
          ],
        },
        subItem: null,
      },
      //{
      //   name: '/phenotypes',
      //   className: 'header3-item',
      //   children: {
      //     href: '/phenotypes',
      //     children: [
      //       {
      //         children: (
      //           <div style={{ display: 'flex', justifyContent: 'center' }}>
      //             <StarFilled />&nbsp;Phenotypes
      //           </div>
      //         ),
      //         name: 'text',
      //       },
      //     ],
      //   },
      // },
      {
        name: '/taxa',
        className: 'header3-item',
        children: {
          href: '/taxa',
          children: [
            {
              children: (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <TagsFilled />&nbsp;Taxa
                </div>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: '/pathogenic',
        className: 'header3-item',
        children: {
          href: '/pathogenic',
          children: [
            {
              children: (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <BugFilled />&nbsp;Pathogenic
                </div>
              ),
              name: 'text',
            },
          ],
        },
      },
      
      {
        name: '/shu',
        className: 'header3-item',
        children: {
          href: '/shu',
          children: [
            {
              children: (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <StarFilled />&nbsp;Phylogeny
                </div>
              ),
              name: 'text',
            },
          ],
        },
      },

      {
        name: '/data',
        className: 'header3-item',
        children: {
          href: '/data',
          children: [
            {
              children: (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <DatabaseFilled />&nbsp;Data
                </div>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: '/help',
        className: 'header3-item',
        children: {
          href: '/help',
          children: [
            {
              children: (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <InfoCircleFilled />&nbsp;Help
                </div>
              ),
              name: 'text',
            },
          ],
        },
      },
    ],
  },
  mobileMenu: { className: 'header3-mobile-menu' },
}
export const Footer00DataSource = {
  wrapper: { className: 'home-page-wrapper footer0-wrapper' },
  OverPack: { className: 'home-page footer0', playScale: 0.05 },
  copyright: {
    className: 'copyright',
    children: (
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '4px 12px',
          minHeight: 80,
          padding: '8px 0',
          boxSizing: 'border-box',
          lineHeight: 1.5,
        }}
      >
        <span>©2026 LRMrepo All Rights Reserved</span>
        <span style={{ whiteSpace: 'nowrap' }}>苏ICP备2026074857号-1</span>
        <span style={{ whiteSpace: 'nowrap' }}>苏公网安备32010402002681号</span>
      </span>
    ),
  },
}
